export const getFirstThree = (arr) => {
  return arr.slice(0, 3);
};
